<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
    	
    	<ul class="tablists">
    		<li v-for="(item,index) in typelists" :style="item.background" @click="handleTabsEdit(item.id)">
				<a :style="item.color" href="javascript:;">{{item.name}}</a>
			</li>
    	</ul>
    	
    	<!-------- 按订单查询销售详情 ---------->
    	<div class="salemain">
    		<el-col :span="24" v-show="typelists[0].show">    		
    			
    			<el-form :inline="true" class="demo-form-inline" size="small">

					<el-form-item>
				        <el-date-picker
				            v-model="query.date"
				            type="daterange"
				            range-separator="至"
				            start-placeholder="开始日期"
				            end-placeholder="结束日期"
				            value-format="yyyy-MM-dd" 
							:unlink-panels="false" 
							clearable
							@change="isselect=true" >
				        </el-date-picker>
			        </el-form-item>

					<el-form-item>
			            <el-select v-model="query.datafrom" clearable filterable @change="isselect=true" placeholder="请选择订单出处">
			                <el-option v-for="(item,index) in datafrom" :key="index" :label="item.name" :value="item.id"></el-option>
			            </el-select> 
		            </el-form-item>
					
					<el-form-item v-if="(query.datafrom==2 || query.datafrom==3) && sourceagents.length > 0">
						<el-select v-model="query.fagentid" clearable filterable placeholder="请选择代理商来源" @change="isselect=true" style="width:100%">
							<el-option v-for="(item,index) in sourceagents" :key="index" :label="item.agentname" :value="item.id"></el-option>
						</el-select>
					</el-form-item>

			        <el-form-item>
				        <el-select v-model="query.clerkid" clearable filterable placeholder="销售员" @change="isselect=true" style="width:100%">
				            <el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
				        </el-select> 
			        </el-form-item>
			        <el-form-item>
				        <el-select v-model="query.customerid" clearable filterable remote reserve-keyword :remote-method="getCustomer" :loading="customerLoading" placeholder="请输入客户名称 / 简称" style="width:100%">
				          	<el-option v-for="(item,index) in customerLists" :key="index" :label="item.showname" :value="item.id"></el-option>
				        </el-select> 
				    </el-form-item>
			        <el-form-item>
				        <el-select v-model="query.account" placeholder="全部支付" clearable filterable @change="isselect=true" style="width:100%">
				            <el-option v-for="(item,index) in paylists" :key="index" :label="item.name" :value="item.id"></el-option>
				        </el-select> 
			        </el-form-item>
			        <el-form-item>
			            <el-select v-model="query.timetype" filterable @change="isselect=true">
			                <el-option v-for="(item,index) in timetype" :key="index" :label="item.name" :value="item.id"></el-option>
			            </el-select> 
		            </el-form-item>       

					<el-form-item>
				        <el-select v-model="query.productid" clearable filterable remote reserve-keyword :remote-method="getgoods" :loading="sellgoodsloading" @change="isselect=true"  placeholder="请输入商品名称 / 编号 / 条形码" style="width:100%">
				          	<el-option v-for="(item,index) in sellgoodslists" :key="index" :label="item.name" :value="item.id"></el-option>
				        </el-select> 
				    </el-form-item>

					<el-form-item>
			          	<el-input placeholder="订单编号" v-model="query.key" clearable @keyup.enter.native="getList" @change="isselect=true"></el-input>
			        </el-form-item>

					<el-form-item>
			          	<el-button type="warning" icon="el-icon-search" @click="getList">查询</el-button>		
			        </el-form-item>

					<el-form-item>	            
			            <el-dropdown @command="sumTypeCkeck">
						    <el-button icon="el-icon-search" type="warning">导出<i class="el-icon-arrow-down el-icon--right"></i></el-button>
						    <el-dropdown-menu slot="dropdown">
							    <el-dropdown-item v-for="(item,index) in orderexportdata" v-text="item.name" :command="item.id" :key="index"></el-dropdown-item>
						    </el-dropdown-menu>
						</el-dropdown>
			        </el-form-item>
	        	</el-form>

				<ul class="stattotal" style="padding:15px 0">
					<li style="border:0;color:#926a61;font-size:13px;font-weight:540">订单金额合计：<i style="font-style:normal;color:#e93f45;font-weight:550">￥{{allstat.total}}</i></li>
					<li style="border:0;color:#926a61;font-size:13px;font-weight:540">应付金额合计：<i style="font-style:normal;color:#e93f45;font-weight:550">￥{{allstat.real}}</i></li>
					<li style="border:0;color:#926a61;font-size:13px;font-weight:540">优惠金额合计：<i style="font-style:normal;color:#e93f45;font-weight:550">￥{{allstat.derate}}</i></li>
					<li style="border:0;color:#926a61;font-size:13px;font-weight:540">已付金额合计：<i style="font-style:normal;color:#e93f45;font-weight:550">￥{{allstat.amount}}</i></li>
    			</ul>

	        	<el-table :data="lists" v-loading="listLoading">
			            <el-table-column type="expand">
				            <template slot-scope="props" v-if="props.row.product.length>0">
				            	<div style="width:100%;color:#606266;padding:10px 0;font-size:12px">
			              	        <span v-if="props.row.truename!=''">收货人：{{props.row.truename}}，{{props.row.phone}}，{{props.row.address}}</span><br/>
			              	        <span v-if="props.row.note!=''">备注：{{props.row.note}}</span>
			              	    </div>
				                <el-table :data="props.row.product">
					                <el-table-column prop="name" label="商品名称" min-width="250">
										<template slot-scope="gprops">
											<span style="float:left;width:100%;font-size:13px;">{{gprops.row.name}}</span>
											<span style="float:left;width:100%;font-size:12px;color:#999999">编号：{{gprops.row.number}}</span>
										</template>
									</el-table-column>
					                <el-table-column prop="dis_sell" label="价格" min-width="120" align="center"></el-table-column>
									<el-table-column prop="num" label="数量" min-width="120" align="center">
										<template slot-scope="gprops">
											<span>{{gprops.row.num}} {{gprops.row.unit}}</span>
										</template>
									</el-table-column>
					                <el-table-column prop="total" label="总价" min-width="120" align="center"></el-table-column>
					                <el-table-column prop="warehousename" label="出库仓库" min-width="120" align="center">
										<template slot-scope="gprops">
											<span style="font-size:13px">{{gprops.row.warehousename}}</span>
										</template>
									</el-table-column>
					                <el-table-column prop="type" label="类型" min-width="120" align="center">
										<template slot-scope="gprops">
											<span style="font-size:13px">{{gprops.row.type}}</span>
										</template>
									</el-table-column>
				                </el-table>
				            </template>
			            </el-table-column>
						<el-table-column label="id" prop="id" min-width="90" />
			            <el-table-column label="订单编号" min-width="250">
							<template slot-scope="scope">
								<div v-if="scope.row.paytype==0">
									<span>{{scope.row.documents}}</span>
								</div>
								<div v-if="scope.row.paytype==1">
									<span>{{scope.row.documents}}<i style="font-size:12px;font-style:normal;color:#999999">（商城）</i></span>
								</div>
								<div v-if="scope.row.paytype==3">
									<span>{{scope.row.documents}}<i style="font-size:12px;font-style:normal;color:#999999">（跑店）</i></span>
								</div>
								<div v-if="scope.row.paytype==4">
									<span>{{scope.row.documents}}<i style="font-size:12px;font-style:normal;color:#999999">（{{scope.row.ordersource}}）</i></span>
								</div>
								<div v-if="scope.row.paytype==5">
									<span>{{scope.row.documents}}<i style="font-size:12px;font-style:normal;color:#999999">（分销）</i></span>
								</div>
								<div v-if="scope.row.paytype==6">
									<span>{{scope.row.documents}}<i style="font-size:12px;font-style:normal;color:#999999">（邀请有礼）</i></span>
								</div>
								<div v-if="scope.row.paytype==7">
									<span>{{scope.row.documents}}<i style="font-size:12px;font-style:normal;color:#999999">（抖音）</i></span>
								</div>
								<div v-if="scope.row.paytype==8">
									<span>{{scope.row.documents}}<i style="font-size:12px;font-style:normal;color:#999999">（天猫）</i></span>
								</div>
								<div v-if="scope.row.paytype==9">
									<span>{{scope.row.documents}}<i style="font-size:12px;font-style:normal;color:#999999">（拼多多）</i></span>
								</div>
								<div style="float:left;width:100%;font-size:12px;line-height:23px;color:#999999;">客户：{{scope.row.customer}}</div>
								<div style="float:left;width:100%;font-size:12px;line-height:23px;color:#999999;">销售员：{{scope.row.clerk}}</div>
							</template>
						</el-table-column>
			            <el-table-column prop="total" label="订单总价" align="center" min-width="120"></el-table-column>
			          	<el-table-column prop="real" label="应付金额" align="center" min-width="120"></el-table-column>
			          	<el-table-column prop="derate" label="优惠金额" align="center" min-width="120"></el-table-column>
			          	<el-table-column prop="amount" label="已付金额" align="center" min-width="120"></el-table-column>
			          	<el-table-column prop="inputtime" label="订单时间" min-width="120" align="center"></el-table-column>
						<el-table-column prop="accountname" label="状态" align="center" min-width="120">
							<template slot-scope="scope">
								<span style="float:left;width:100%;font-size:13px" v-if="scope.row.status==0">未审核，{{scope.row.accountname}}</span>
								<span style="float:left;width:100%;font-size:13px" v-if="scope.row.status==1">已审核，{{scope.row.accountname}}</span>
								<span style="float:left;width:100%;font-size:13px" v-if="scope.row.status==2">已完成，{{scope.row.accountname}}</span>
								<span style="float:left;width:100%;font-size:13px" v-if="scope.row.status==3">已撤销，{{scope.row.accountname}}</span>
							</template>
						</el-table-column>
	        		</el-table>
			        <div class="block">
			        <!--分页begin-->
			          <el-pagination
			            @size-change="pageSizeChange"
			            @current-change="pageCurrentChange"
			            :current-page="query.p"
			            :page-sizes="[10, 20, 50]"
			            :page-size="query.rollpage"
			            layout="total, sizes, prev, pager, next, jumper"
			            :total="total_rows">
			          </el-pagination>
			          <!--分页end-->
			        </div>
			</el-col>
			
			<!-------- 按商品查询销售详情 ---------->
	    	<el-col :span="24" v-show="typelists[1].show">
	    		<el-form :inline="true" class="demo-form-inline" size="small">
					<el-form-item>
			            <el-date-picker
			              v-model="productquery.date" clearable
			              type="daterange"
			              range-separator="至"
			              start-placeholder="开始日期"
			              end-placeholder="结束日期"
						  :unlink-panels="false"
			              value-format="yyyy-MM-dd" style="width:100%" @change="productisselect=true">
			            </el-date-picker>
			        </el-form-item>
	    			<el-form-item>
				        <el-select v-model="productquery.customerid" clearable filterable remote reserve-keyword :remote-method="getCustomer" :loading="customerLoading" placeholder="请输入客户名称 / 简称" style="width:100%">
				          	<el-option v-for="(item,index) in customerLists" :key="index" :label="item.showname" :value="item.id"></el-option>
				        </el-select> 
				    </el-form-item>
			        <el-form-item>
				    	<el-select v-model="productquery.clerkid" clearable filterable placeholder="全部销售员" @change="productisselect=true">
				            <el-option label="全部销售员" value="0"></el-option>
				            <el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
				        </el-select> 
			        </el-form-item>
			        <el-form-item>
			            <el-select v-model="productquery.brandid" clearable filterable placeholder="按品牌" @change="productisselect=true">
			                <el-option label="不选品牌" value=""></el-option>
			                <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
			                	<span style="float: left">{{item.name}}</span>
      				      		<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
			                </el-option>
			            </el-select>
			        </el-form-item>
			        <el-form-item>
			            <el-cascader :options="categorylist" clearable v-model="productquery.catid" placeholder="选择分类" @change="productisselect=true"></el-cascader>
			        </el-form-item>
			        <el-form-item>
			              <el-input placeholder="请输入关键字" style="width:100%" v-model="productquery.key" clearable @change="productisselect=true" @keyup.enter.native="getproductList"></el-input>
			        </el-form-item>
					<el-form-item>
			            <el-button type="warning" icon="el-icon-search" @click="getproductList">查询</el-button>
			        </el-form-item>
			        <el-form-item>
			            <el-button type="warning" icon="el-icon-search" @click="getproductexport">导出销售信息</el-button>
			        </el-form-item>
			    </el-form>

				<ul class="stattotal" style="padding:15px 0;">
					<li style="border:0;color:#926a61;font-size:13px;font-weight:540">
					商品销售合计：
					<i style="font-style:normal;color:#e93f45;font-weight:550">￥{{amounts}}</i>
					</li>
    			</ul>

				<el-table :data="productlists" v-loading="productlistLoading">
					<el-table-column prop="productid" label="id" min-width="90" align="center"></el-table-column>
				    <el-table-column prop="name" label="商品" min-width="250">
						<template slot-scope="scope">
							<span style="float:left;width:100%;font-size:13px">{{scope.row.name}}</span>
							<span style="float:left;width:100%;font-size:12px;color:#999999">编号：{{scope.row.number}}</span>
						</template>
					</el-table-column>
				    <el-table-column prop="buy" label="最新进货价" min-width="120" align="center"></el-table-column>
				    <el-table-column prop="sell" label="最新批发价" min-width="120" align="center"></el-table-column>
				    <el-table-column prop="nums" label="销售数量" min-width="120" align="center"><template slot-scope="scope">
							<span style="float:left;width:100%;font-size:13px">{{scope.row.nums}} {{scope.row.baseunit}}</span>
						</template>
					</el-table-column>
				    <el-table-column prop="amount" label="销售金额" min-width="120" align="center"></el-table-column>
				</el-table>
				<div class="block">
				    <!--分页begin-->
				    <el-pagination
				        @size-change="productpageSizeChange"
				        @current-change="productpageCurrentChange"
				        :current-page="productquery.p"
				        :page-sizes="[10, 20, 50,1000]"
				        :page-size="productquery.rollpage"
				        layout="total, sizes, prev, pager, next, jumper"
				        :total="product_total_rows">
				    </el-pagination>
				    <!--分页end-->
				</div>    		
	    	</el-col>
	    	
	    	<!----------------- 按客户统计 --------------------->
	    	<el-col :span="24" v-show="typelists[2].show">
	    		<el-form :inline="true" class="demo-form-inline" size="small">
				    <el-form-item>
		                <el-date-picker v-model="customerquery.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :unlink-panels="false"></el-date-picker>
		            </el-form-item>
				    <el-form-item>
		          	    <el-select v-model="customerquery.brandid" clearable filterable placeholder="请选择品牌">
		              	    <el-option label="不分品牌" value="0"></el-option>
		                    <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
		                    	<span style="float: left">{{item.name}}</span>
      				      		<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
		                    </el-option>
		                </el-select>
		            </el-form-item>
				    <el-form-item>
		                <el-cascader :options="categorylist" v-model="customerquery.catid" placeholder="请选择分类" clearable></el-cascader>
		            </el-form-item>
		            <el-form-item>
				    	<el-select v-model="customerquery.clerkid" clearable filterable placeholder="全部销售员" @change="productisselect=true">
				            <el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
				        </el-select> 
			        </el-form-item>
		            <el-form-item>
		          	    <el-select v-model="customerquery.type" filterable>
		                    <el-option v-for="(item,index) in customertypelists" :label="item.name" :value="item.id" :key="index"></el-option>
		                </el-select>
		            </el-form-item>
		            <el-form-item>
		                <el-select v-model="customerquery.productid" clearable filterable remote reserve-keyword :remote-method="getProducts" :loading="customerLoading" placeholder="请选择商品" v-if="customerquery.type==1">
		          			<el-option v-for="(item,index) in searchproducts" :key="index" :label="item.name" :value="item.id"></el-option>
		        	    </el-select>
		            </el-form-item>
					<el-form-item>
		                <el-select v-model="customerquery.customer" clearable filterable remote reserve-keyword :remote-method="getCustomer" :loading="customerLoading" placeholder="请选择客户" v-if="customerquery.type==2">
		          			<el-option v-for="(item,index) in customerLists" :key="index" :label="item.name" :value="item.id"></el-option>
		        	    </el-select> 
		            </el-form-item>
		            
		            <el-form-item>
				        <el-select v-model="customerquery.account" placeholder="全部支付" clearable filterable @change="isselect=true">
				            <el-option v-for="(item,index) in paylists" :key="index" :label="item.name" :value="item.id"></el-option>
				        </el-select> 
		            </el-form-item>

		            <el-form-item>
				        <el-input v-model="customerquery.startprice" placeholder="金额下限"></el-input>
		            </el-form-item>
		            <el-form-item style="width:1%">~</el-form-item>
		            <el-form-item>
		            	<el-input v-model="customerquery.endprice" placeholder="金额上限"></el-input>
		            </el-form-item>		
					
					<el-form-item>
		                <el-button type="warning" icon="el-icon-search" @click="customergetlists">查询</el-button>
		            </el-form-item>

					<el-form-item>
						<el-dropdown @command="customersumTypeCkeck">
							<el-button icon="el-icon-download" size="small" type="warning">导出</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item v-for="(item,index) in customerexportdata" v-text="item.name" :command="item.id" :key="index"></el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
		            </el-form-item>

		        </el-form>
		        
		        <el-table :data="customerslists" v-loading="customerlistLoading">
		            <el-table-column prop="name" label="客户名称" min-width="250">
						<template slot-scope="scope">
							<span style="font-size:13px">{{scope.row.name}}</span>
						</template>
					</el-table-column>
		            <el-table-column prop="number" label="订单笔数" min-width="100" align="center"></el-table-column>
		            <el-table-column prop="total" label="订单金额" min-width="120" align="center"></el-table-column>
		            <el-table-column prop="derate" label="优惠金额" min-width="120" align="center"></el-table-column>
		            <el-table-column prop="real" label="应付金额" min-width="120" align="center"></el-table-column>
		            <el-table-column prop="gift" label="赠品金额" min-width="120" align="center"></el-table-column>
		            <el-table-column prop="gross" label="毛利" min-width="120" align="center"></el-table-column>
		            <el-table-column prop="percent" label="毛利率" min-width="120" align="center"></el-table-column>
		            <!--
		            <el-table-column label="操作" width="220" align="center">
		                <template slot-scope="scope">
		                    <el-button type="primary" size="small" icon="el-icon-search" @click="editCurrent(scope.row)">查看</el-button>
		                    <el-button type="primary" size="small" icon="el-icon-edit-outline" @click="exportdata(scope.row)">导出明细</el-button>
		                </template>
		            </el-table-column>
		            -->
		        </el-table>
		        <div class="block">
		            <el-pagination
		                @size-change="customerpageSizeChange"
		                @current-change="customerpageCurrentChange"
		                :current-page="customerquery.p"
		                :page-sizes="[10, 20, 50]"
		                :page-size="customerquery.rollpage"
		                layout="total, sizes, prev, pager, next, jumper"
		                :total="customertotal_rows">
		            </el-pagination>
		        </div>   
    		</el-col>
    		
    		<!----------------- 按区域统计 --------------------->
	    	<el-col :span="24" v-show="typelists[3].show">
	    		<el-form :inline="true" class="demo-form-inline" size="small">
				    <el-form-item>
		                <el-date-picker 
						 v-model="areaquery.date" 
						 type="daterange" 
						 range-separator="至" 
						 start-placeholder="开始日期" 
						 end-placeholder="结束日期" 
						 value-format="yyyy-MM-dd" 
						 :unlink-panels="false"  
						 @change="areaselect=true">
						</el-date-picker>
		            </el-form-item>
				    <el-form-item>
		          	    <el-select v-model="areaquery.brandid" clearable filterable placeholder="请选择品牌" @change="areaselect=true">
		                    <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
		                    	<span style="float: left">{{item.name}}</span>
      				      		<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
		                    </el-option>
		                </el-select>
		            </el-form-item>
		            <el-form-item>
			            <el-input placeholder="请输入关键字" style="width:100%" v-model="areaquery.key" clearable @change="areaselect=true"></el-input>
			        </el-form-item>
		            <el-form-item>
		                <el-button type="warning" icon="el-icon-search" @click="areagetlists">查询</el-button>
		            </el-form-item>
					<el-form-item>
		                <el-button type="warning" icon="el-icon-edit-outline" @click="areaexportdatamore">导出</el-button>
		            </el-form-item>		      		            
		        </el-form>
	    	
	    		<div style="float:left;width:100%;overflow:auto;" v-loading="areaLoading">
        		<table border="0" cellspacing="0" cellpadding="0" class="tableshow1">
		    		<tr>
		    			<th align="left" v-for="(item,index) in areatitle1" :key="index"  v-if="index <= 3" rowspan="2">{{item}}</th>
		    			<th align="center" v-for="(item,index) in areatitle1" :key="index"  v-if="index > 3" colspan="2">{{item}}</th>
		      		</tr>
		      		<tr>
		    			<th align="center" v-for="(item,index) in areatitle2" :key="index">{{item}}</th>
		      		</tr>
					<tr v-for="(item,index) in arealists.lists">
						<td align="left">{{item.number}}</td>
						<td align="left">{{item.name}}</td>
						<td align="left">{{item.spec}}</td>
						<td align="left">{{item.unit}}</td>
						<template v-for="(tt,ii) in item.district">
						<td align="center">{{tt.nums}}</td>
						<td align="center">{{tt.total}}</td>
						</template>
						<td align="center">{{item.allnum}}</td>
						<td align="center">{{item.amount}}</td>
					</tr>
		   	    </table>
		    	</div>
		    	<div class="block" style="float:left;width:100%">
		            <el-pagination
		                @size-change="areapageSizeChange"
		                @current-change="areapageCurrentChange"
		                :current-page="areaquery.p"
		                :page-sizes="[10, 20, 50]"
		                :page-size="areaquery.rollpage"
		                layout="total, sizes, prev, pager, next, jumper"
		                :total="area_rows">
		            </el-pagination>
		        </div>
	    	</el-col>
	    	
	    	<!-------- 按销售员查询销售详情 ---------->
	    	<el-col :span="24" v-show="typelists[4].show">
	    		<el-form :inline="true" class="demo-form-inline" size="small">
				    <el-form-item>
		                <el-date-picker 
						 v-model="sellquery.date" 
						 type="daterange" 
						 range-separator="至" 
						 start-placeholder="开始日期" 
						 end-placeholder="结束日期" 
						 value-format="yyyy-MM-dd" 
						 :unlink-panels="false" 
						 @change="sellselect=true">
						</el-date-picker>
		            </el-form-item>
				    <el-form-item>
		          	    <el-select v-model="sellquery.brandid" clearable filterable placeholder="请选择品牌" @change="sellselect=true">
		                    <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
		                    	<span style="float: left">{{item.name}}</span>
      				      		<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
		                    </el-option>
		                </el-select>
		            </el-form-item>
		            <el-form-item>
		                <el-select v-model="sellquery.clerkid" clearable filterable placeholder="全部销售员" @change="sellselect=true">
				            <el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
				        </el-select> 		                
		            </el-form-item>
		            <el-form-item ref="query" :model="query">
			            <el-input placeholder="商品名称/编号" style="width:100%" v-model="sellquery.key" clearable @change="sellselect=true"></el-input>
			        </el-form-item>
		            <el-form-item>
		                <el-button type="warning" icon="el-icon-search" @click="sellgetlists">查询</el-button>					
					</el-form-item>
					<el-form-item>
						<el-dropdown @command="clerksumTypeCkeck">
							<el-button icon="el-icon-download" size="small" type="warning">导出</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item v-for="(item,index) in clerkexportdata" v-text="item.name" :command="item.id" :key="index"></el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>	
					</el-form-item>		      		            
		        </el-form>

				<ul class="stattotal" style="padding:15px 0">
					<li style="border:0;color:#926a61;font-size:13px;font-weight:540">销售金额合计：<i style="font-style:normal;color:#e93f45;font-weight:550">￥{{allsale}}</i></li>
					<li style="border:0;color:#926a61;font-size:13px;font-weight:540">实付金额合计：<i style="font-style:normal;color:#e93f45;font-weight:550">￥{{allreal}}</i></li>
					<li style="border:0;color:#926a61;font-size:13px;font-weight:540">退款金额合计：<i style="font-style:normal;color:#e93f45;font-weight:550">￥{{allrefund}}</i></li>
					<li style="border:0;color:#926a61;font-size:13px;font-weight:540">未付款金额合计：<i style="font-style:normal;color:#e93f45;font-weight:550">￥{{allpay}}</i></li>
				</ul>
		        
		        <el-table :data="sellsalelists" v-loading="sellLoading">
		            <el-table-column prop="clerkname" label="销售员" min-width="250">
						<template slot-scope="scope">
							<span style="font-size:13px">{{scope.row.clerkname}}</span>
						</template>
					</el-table-column>
		            <el-table-column prop="sale" label="销售额"  min-width="120" align="center"></el-table-column>
		            <el-table-column prop="real" label="实付金额"  min-width="120" align="center"></el-table-column>
					<el-table-column prop="profit" label="利润"  min-width="120" align="center"></el-table-column>
		            <el-table-column prop="refund" label="退款金额"  min-width="120" align="center"></el-table-column>
		            <el-table-column prop="pay" label="未收账款"  min-width="120" align="center"></el-table-column>
		        </el-table>
		        <div class="block">
		            <el-pagination
		                @size-change="sellpageSizeChange"
		                @current-change="sellpageCurrentChange"
		                :current-page="sellquery.p"
		                :page-sizes="[10, 20, 50]"
		                :page-size="sellquery.rollpage"
		                layout="total, sizes, prev, pager, next, jumper"
		                :total="sell_rows">
		            </el-pagination>
		        </div>
	    	</el-col>	
			
			<!-------- 按品牌查询 ---------->
	    	<el-col :span="24" v-show="typelists[5].show && typelists[5].detailId == ''">
	    		<el-form :inline="true" class="demo-form-inline" size="small">
				    <el-form-item>
		                <el-date-picker 
						 v-model="brandQuery.date" 
						 type="daterange" 
						 range-separator="至" 
						 start-placeholder="开始日期" 
						 end-placeholder="结束日期" 
						 value-format="yyyy-MM-dd" 
						 :unlink-panels="false" 
						 @change="sellselect=true">
						</el-date-picker>
		            </el-form-item>
				    <el-form-item>
		          	    <el-select v-model="brandQuery.brandid" clearable filterable placeholder="请选择品牌" @change="sellselect=true">
		                    <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
		                    	<span style="float: left">{{item.name}}</span>
      				      		<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
		                    </el-option>
		                </el-select>
		            </el-form-item>
		            
		            <el-form-item>
		                <el-button type="warning" icon="el-icon-search" @click="brandSearch">查询</el-button>					
					</el-form-item>
					<!-- <el-form-item>
						<el-dropdown @command="clerksumTypeCkeck">
							<el-button icon="el-icon-download" size="small" type="warning">导出</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item v-for="(item,index) in clerkexportdata" v-text="item.name" :command="item.id" :key="index"></el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>	
					</el-form-item>		      		             -->
		        </el-form>
		        
		        <el-table :data="brandList" v-loading="brandLoading">
		            <el-table-column prop="name" label="品牌名称" align="center"></el-table-column>
		            <el-table-column prop="amount" label="销售金额" align="center"></el-table-column>
					<el-table-column prop="order_number" label="下单次数" align="center"></el-table-column>
		            <el-table-column prop="order_customer" label="销售客户数" align="center"></el-table-column>
		            <el-table-column prop="pay" label="操作" align="center">
						<template slot-scope="scope">
							<el-button type="text" size="mini" @click="showDetail(scope.row.agentbrandid)">查看明细</el-button>
						</template>
					</el-table-column>
		        </el-table>
		        <div class="block">
		            <el-pagination
		                @size-change="brandpageSizeChange"
		                @current-change="brandpageCurrentChange"
		                :current-page="brandQuery.p"
		                :page-sizes="[1, 10, 20, 50]"
		                :page-size="brandQuery.rollpage"
		                layout="total, sizes, prev, pager, next, jumper"
		                :total="brandQueryTotal">
		            </el-pagination>
		        </div>
	    	</el-col>
			<el-col :span="24" v-show="typelists[5].show && typelists[5].detailId != ''">
	    		<div>
					<el-button type="" size="mini" @click="detailBack">返回</el-button>
				</div>
		        
		        <el-table :data="detailList" v-loading="detailLoading">
		            <el-table-column prop="name" label="客户名称" align="center"></el-table-column>
		            <el-table-column prop="order_number" label="下单次数" align="center"></el-table-column>
					<el-table-column prop="amount" label="销售金额" align="center"></el-table-column>
		        </el-table>
		        <div class="block">
		            <el-pagination
		                @size-change="detailSizeChange"
		                @current-change="detailCurrentChange"
		                :current-page="detailquery.p"
		                :page-sizes="[10, 20, 50]"
		                :page-size="detailquery.rollpage"
		                layout="total, sizes, prev, pager, next, jumper"
		                :total="detailTotal">
		            </el-pagination>
		        </div>
	    	</el-col>
    	</div>

		<!-- 导出订单信息（按销售员） -->
	    <el-dialog title="导出商品销售信息确认" :visible.sync="clerksellDialog" width="98%" top="5vh">
	      	<el-button size="medium" type="danger" @click="clerkoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	<div id="outputorder">
		      	<el-table :data="clerksalelists" border v-loading="clerkLoading">
		      	  	<el-table-column prop="documents" label="订单编号" width="90"></el-table-column>
		          	<el-table-column prop="clerkname" label="销售员名称"></el-table-column>
		          	<el-table-column prop="customername" label="客户名称"></el-table-column>
					<el-table-column prop="accountname" label="支付方式"></el-table-column>
		          	<el-table-column prop="total" label="订单金额" align="center"></el-table-column>
		          	<el-table-column prop="real" label="实付金额" align="center"></el-table-column>
		          	<el-table-column prop="pay" label="未付款金额" align="center"></el-table-column>
		          	<el-table-column prop="profit" label="利润" align="center"></el-table-column>
		          	<el-table-column prop="inputtime" label="下单时间" align="center"></el-table-column>
		          	<el-table-column prop="finishtime" label="完成时间" align="center"></el-table-column>
		      	</el-table>
	      	</div>
	      	<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="clerksellDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="clerkoutput">确认导出</el-button>
		    </div>	                
	    </el-dialog>

    		
    	<!------------- 订单列表导出信息 ----------------->	
	    <el-dialog title="导出订单信息确认" :visible.sync="outputDialog" width="98%" top="5vh">
	      	<el-button size="medium" type="danger" @click="sureoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	<div id="outputorder">
		      	<el-table :data="outlists" border v-loading="outlistsLoading">
		      	  	<el-table-column prop="documents" label="订单编号" width="90"></el-table-column>
					<el-table-column prop="paytype" label="订单来源" width="90"></el-table-column>
		          	<el-table-column prop="customer" label="客户名称"></el-table-column>
		          	<el-table-column prop="district_name" label="所在区域"></el-table-column>
		          	<el-table-column prop="clerk" label="销售员" align="center"></el-table-column>
		          	<el-table-column prop="accountname" label="支付方式" align="center"></el-table-column>
		          	<el-table-column prop="inputtime" label="下单时间" width="100" align="center"></el-table-column>
		          	<el-table-column prop="verifytime" label="审核时间" width="100" align="center"></el-table-column>
		          	<el-table-column prop="finishtime" label="完成时间" width="100" align="center"></el-table-column>
		          	<el-table-column prop="num" label="总数量" align="center"></el-table-column>
		            <el-table-column prop="total" label="订单总价" align="center"></el-table-column>
		          	<el-table-column prop="real" label="实付金额" align="center"></el-table-column>
		          	<el-table-column prop="derate" label="优惠金额" align="center"></el-table-column>
		          	<el-table-column prop="express" label="快递费" align="center"></el-table-column>
		          	<el-table-column prop="amount" label="已付金额" align="center"></el-table-column>	          	  	          	  
		          	<el-table-column prop="note" label="备注"></el-table-column>
		      	</el-table>
	      	</div>
	      	<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="outputDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="sureoutput">确认导出</el-button>
		    </div>	                
	    </el-dialog>
	    
	    <!------------- 订单详情导出信息 ----------------->	
	    <el-dialog title="导出订单详情信息确认" :visible.sync="outputdetailDialog" width="98%" top="5vh">
	      	<el-button size="medium" type="danger" @click="suredetailoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	<div id="outputorder">
		      	<el-table :data="outldetailists" border v-loading="outdetailLoading">
		      	  	<el-table-column prop="documents" label="订单编号" width="90"></el-table-column>
					<el-table-column prop="paytype" label="订单来源" width="90"></el-table-column>
		          	<el-table-column prop="inputtime" label="下单时间"></el-table-column>
		          	<el-table-column prop="verifytime" label="审核时间"></el-table-column>
		          	<el-table-column prop="finishtime" label="完成时间" align="center"></el-table-column>
		          	<el-table-column prop="customername" label="客户" align="center"></el-table-column>
		          	<el-table-column prop="clerkname" label="销售员" align="center"></el-table-column>
		          	<el-table-column prop="total" label="订单金额" align="center"></el-table-column>
		          	<el-table-column prop="real" label="应付金额" align="center"></el-table-column>
		          	<el-table-column prop="derate" label="优惠金额" align="center"></el-table-column>
		            <el-table-column prop="amount" label="已付金额" align="center"></el-table-column>
		          	<el-table-column prop="status" label="订单状态" align="center"></el-table-column>
		          	<el-table-column prop="account" label="支付" align="center"></el-table-column>
		          	<el-table-column prop="number" label="商品编码" align="center"></el-table-column>
		          	<el-table-column prop="brandname" label="品牌" align="center"></el-table-column>
					<el-table-column prop="code" label="条形码" align="center"></el-table-column>
					<el-table-column prop="cate" label="品类" align="center"></el-table-column>	    	          	  	          	  
		          	<el-table-column prop="name" label="商品名称"></el-table-column>
		          	<el-table-column prop="sell" label="价格"></el-table-column>
		          	<el-table-column prop="market" label="零售价"></el-table-column>
		          	<el-table-column prop="discount" label="折扣（%）"></el-table-column>
		          	<el-table-column prop="num" label="数量"></el-table-column>
		          	<el-table-column prop="spec" label="规格"></el-table-column>
		          	<el-table-column prop="unit" label="单位"></el-table-column>
		          	<el-table-column prop="cost" label="成本小计"></el-table-column>
		          	<el-table-column prop="goodstotal" label="销售金额小计"></el-table-column>
		          	<el-table-column prop="warehousename" label="仓库"></el-table-column>
		          	<el-table-column v-if="storageLocationStatus" label="货位">
						<template slot-scope="scope">
							<div v-for="item in scope.row.storage_location" :key="item.id">
								<span>{{ item.full_code }}</span>
							</div>
						</template>
					</el-table-column>
		          	<el-table-column prop="type" label="类型"></el-table-column>
		          	<el-table-column prop="note" label="订单备注"></el-table-column>
		          	<el-table-column label="分拣箱号">
						<template slot-scope="scope">
							<div v-for="item in scope.row.sorting_box" :key="item.name">
								<span>{{ item.box_name }}号箱：</span>
								<span>{{ item.box_volume }}</span>
							</div>
						</template>
					</el-table-column>
		          	<el-table-column prop="verifyer_name" label="审核人员"></el-table-column>
		      	</el-table>
	      	</div>
	      	<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="outputdetailDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="suredetailoutput">确认导出</el-button>
		    </div>	                
	    </el-dialog>
    	
    	<!--------- 按商品导出信息 ------------>
	    <el-dialog title="导出商品销售信息确认" :visible.sync="goodsDialog" width="98%" top="5vh">
	      	<el-button size="medium" type="danger" @click="productoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	<div id="outputorder">
		      	<el-table :data="goodsLists" border v-loading="goodsLoading">
		      	  	<el-table-column prop="number" label="商品编号" width="90"></el-table-column>
		          	<el-table-column prop="brandname" label="品牌名称"></el-table-column>
		          	<el-table-column prop="name" label="商品名称"></el-table-column>
		          	<el-table-column prop="spec" label="规格" align="center"></el-table-column>
		          	<el-table-column prop="buy" label="最新进货价" align="center"></el-table-column>
		          	<el-table-column prop="sell" label="最新批发价" align="center"></el-table-column>
		          	<el-table-column prop="sellnum" label="销售数量" align="center"></el-table-column>
		          	<el-table-column prop="unit" label="单位" align="center"></el-table-column>
		          	<el-table-column prop="selltotal" label="销售金额" align="center"></el-table-column>
		            <el-table-column prop="storagenum" label="剩余库存数量" align="center"></el-table-column>
		          	<el-table-column prop="storagetotal" label="剩余库存金额" align="center"></el-table-column>
		      	</el-table>
	      	</div>
	      	<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="goodsDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="productoutput">确认导出</el-button>
		    </div>	                
	    </el-dialog>
	    
	    <!--------- 按客户导出信息 ------------>
	    <el-dialog title="导出客户销售信息确认" :visible.sync="customerDialog" width="98%" top="5vh">
	      	<el-button size="medium" type="danger" @click="customeroutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	<div id="outputorder">
		      	<el-table :data="customersexport" border v-loading="customerexportLoading">
		      	  	<el-table-column prop="customername" label="客户名称" width="90"></el-table-column>
		          	<el-table-column prop="documents" label="订单编号"></el-table-column>
		          	<el-table-column prop="inputtime" label="下单时间"></el-table-column>
		          	<el-table-column prop="finishtime" label="完成时间" align="center"></el-table-column>
		          	<el-table-column prop="brandname" label="品牌" align="center"></el-table-column>
		          	<el-table-column prop="number" label="商品编号" align="center"></el-table-column>
		          	<el-table-column prop="spec" label="规格" align="center"></el-table-column>
		          	<el-table-column prop="sell" label="售价" align="center"></el-table-column>
		          	<el-table-column prop="num" label="数量" align="center"></el-table-column>
		          	<el-table-column prop="unit" label="单位" align="center"></el-table-column>
		            <el-table-column prop="sellprice" label="批发价" align="center"></el-table-column>
		          	<el-table-column prop="market" label="零售价" align="center"></el-table-column>
		          	<el-table-column prop="total" label="合计金额" align="center"></el-table-column>
		          	<el-table-column prop="type" label="类型" align="center"></el-table-column>
		          	<el-table-column prop="desc" label="备注" align="center"></el-table-column>
		      	</el-table>
	      	</div>
	      	<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="customerDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="customeroutput">确认导出</el-button>
		    </div>	                
	    </el-dialog>

		<!--------- 按区域导出信息 ------------>
	    <el-dialog title="导出客户销售信息确认2" :visible.sync="customerstatdataDialog" width="98%" top="5vh">
	      	<el-button size="medium" type="danger" @click="customerstatoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	<div id="outputorder">
		      	<el-table :data="customerstatdata" border v-loading="customerstatdataloading">
		      	  	<el-table-column prop="name" label="客户名称"></el-table-column>
					<el-table-column prop="phone" label="客户手机"></el-table-column>
					<el-table-column prop="city" label="城市"></el-table-column>
					<el-table-column prop="address" label="详细地址"></el-table-column>
					<el-table-column prop="number" label="订单笔数"></el-table-column>
					<el-table-column prop="total" label="订单金额"></el-table-column>
					<el-table-column prop="derate" label="优惠金额"></el-table-column>
					<el-table-column prop="real" label="应付金额"></el-table-column>
					<el-table-column prop="gift" label="赠品金额"></el-table-column>
					<el-table-column prop="gross" label="毛利"></el-table-column>
					<el-table-column prop="percent" label="毛利率"></el-table-column>
		      	</el-table>
	      	</div>
	      	<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="customerstatdataDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="customerstatoutput">确认导出</el-button>
		    </div>	                
	    </el-dialog>
	    
	    <!--------- 按区域导出信息 ------------>
	    <el-dialog title="导出区域销售信息确认" :visible.sync="areaDialog" width="98%" top="5vh">
	      	<el-button size="medium" type="danger" @click="areaoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	<div id="outputorder" style="float:left;width:100%;overflow:auto;">
		      	<table border="0" cellspacing="0" cellpadding="0" class="tableshow1">
		    		<tr>
		    			<th align="center" v-for="(item,index) in areaexport.title" :key="index">{{item}}</th>
		      		</tr>
					<tr v-for="(item,index) in areaexport.lists">
						<td align="center">{{item.number}}</td>
						<td align="center">{{item.name}}</td>
						<td align="center">{{item.spec}}</td>
						<td align="center">{{item.unit}}</td>
						<template v-for="(tt,ii) in item.district">
						<td align="center">{{tt.nums}}</td>
						<td align="center">{{tt.total}}</td>
						</template>
						<td align="center">{{item.allnum}}</td>
						<td align="center">{{item.amount}}</td>
					</tr>
		   	    </table>
	      	</div>
	      	<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="areaDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="areaoutput">确认导出</el-button>
		    </div>	                
	    </el-dialog>
    	    	
    </div>
    </transition>
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Stat/index",
      transitionshow:true,
      actionauth:[],
      tabvalue:1,
      typelists:[
      	{id:1,name:'按订单',background:{background:'#909399',padding:'8px 20px'},color:{color:"#fff"},show:false},
      	{id:2,name:'按商品',background:{background:'#909399',padding:'8px 20px'},color:{color:"#fff"},show:false},
      	{id:3,name:'按客户',background:{background:'#909399',padding:'8px 20px'},color:{color:"#fff"},show:false},
      	{id:4,name:'按区域',background:{background:'#909399',padding:'8px 20px'},color:{color:"#fff"},show:false},
      	{id:5,name:'按销售员',background:{background:'#909399',padding:'8px 20px'},color:{color:"#fff"},show:false},
      	{id:6,name:'按品牌', detailId: '',background:{background:'#909399',padding:'8px 20px'},color:{color:"#fff"},show:false}
      ],
      listLoading:false,
      lists:[],
      query:{
        act:'lists',
        token:this.$cookies.get('token'),
        key:'',
        rollpage: 10, // 页大小
        p: 1,
        date:[new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate()],
        clerkid:'',
        customerid:'',
        account:'',
        timetype:4,
		datafrom:'',
		fagentid:'',
		productid:'',
      },
      total_rows:0,
      sellerLists:[],
      isselect:false,
	  sellgoodsloading:false,
	  sellgoodslists:[],
      customerlists:[],
      customerLoading:false,
      paylists:[],
      allstat:[],
      productquery:{
        act:'product',
        token:this.$cookies.get('token'),
        customerid:'',
        brandid:'',
        clerkid:'',
        catid:[],
        date:[],
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      brandlists:[],
      categorylist:[],
      amounts:0,
      productlists:[],
	  productlistLoading:false,
	  product_total_rows:0,
	  timetype:[{id:4,name:'全部订单（全部状态）'},{id:1,name:'下单时间（已完成状态）'},{id:2,name:'审核时间（已完成状态）'},{id:3,name:'完成时间（已完成状态）'}],
	  orderexportdata:[{id:1,name:'导出订单列表'},{id:2,name:'导出订单明细'}],
	  outlistsLoading:false,
	  outputDialog:false,
	  outlists:[],
	  exporthead:[],
	  exportfield:[],
	  exportlists:[],
	  exportname:'',
	  outdetailLoading:false,
	  outputdetailDialog:false,
	  outldetailists:[],
	  goodsDialog:false,
	  goodsLoading:false,
	  goodsLists:[],
	  customerquery: {
          token:this.$cookies.get('token'),
          act:'customerstat',
          key:'',
          rollpage: 10, // 页大小
          p: 1,
          date:[],
          clerkid:'',
          account:'',
          brandid:'',
          catid:'',
          customer:'',
          type:1,
          productid:'',
          startprice:'',
          endprice:'',
      },
      customerslists:[],
      customerlistLoading:false,
      customertotal_rows:0,
      customertypelists:[
      	  {id:1,name:'按产品'},
      	  {id:2,name:'按客户'},
      ],
      showformmore:{height:'auto'},
      
      areaLoading:false,
      arealists:[],
      area_rows:0,
      areaquery: {
          token:this.$cookies.get('token'),
          act:'areastat',
          p: 1,
          rollpage: 10, // 页大小
          brandid:'',
          key:'',
          date:[],
      },
      areatitle1:[],
      areatitle2:[],
      areaselect:false,
	  sellquery: {
	  	  token:this.$cookies.get('token'),
          act:'sellstatnew',
          p: 1,
          rollpage: 10, // 页大小
          brandid:'',
          clerkid:'',
          key:'',
          date:[],
	  },
	  sellsalelists:[],
	  sell_rows:0,
	  sellLoading:false,
	  allsale:0,
	  allreal:0,
	  allrefund:0,
	  allpay:0,
	  customerexportLoading:false,
	  customersexport:[],
	  customerDialog:false,
	  areaDialog:false,
	  areaexportLoading:false,
	  areaexport:[],
	  searchproducts:[],
	  datafrom:[{id:1,name:'销售出库'},{id:2,name:'线上商城'},{id:3,name:'分销'},{id:4,name:'抽奖'},{id:6,name:'邀请有礼'}],  
	  clerksellDialog:false,
	  clerkLoading:false,
	  clerksalelists:[],
	  sourceagents:[], //商城、分销订单来源
	  customerexportdata:[{id:1,name:'导出客户销售信息列表'},{id:2,name:'导出客户统计销售信息'}],
	  customerLists: [],
	  customerstatdata:[],
	  customerstatdataDialog:false,
	  customerstatdataloading:false,
	  clerkexportdata:[{id:1,name:'导出商品销售信息统计'},{id:2,name:'导出销售员导出品牌销售信息统计'}],
	  storageLocationStatus: false,
	  brandQuery: {
		token: this.$cookies.get('token'),
		date: [],
		brandid: '',
		act: 'product_brand',
		p: 1,
		rollpage: 10
	  },
	  brandQueryTotal: 0,
	  brandList: [],
	  brandLoading: false,
	  detailList: [],
	  detailLoading: false,
	  detailTotal: 0,
	  detailquery: {
		p: 1,
		rollpage: 10,
		act:'product_brand_detail',
		token:this.$cookies.get('token'),
		date: [],
		brandid: ''
	  }
    }
  },
  mounted(){    
  	this.getactionauth(); //获取权限设置
  	this.getSeller(); //获取销售员信息
  	this.getpaylists(); //获取支付方式列表
  	this.getBrand(); //获取品牌信息
  	this.getCategoryList(); //获取商品分类信息
  	this.handleTabsEdit(1);
	this.getsourceagent(); //获取线上商城、分销订单来源
	this.storageLocationStatus = localStorage.getItem('storageLocationStatus') == 'true'
  },
  
  methods:{
    showDetail(id) {
		this.typelists[5].detailId = id
		this.getDetailList(id)

	},
	detailBack() {
		this.typelists[5].detailId = ''
		this.detailTotal = 0
		this.detailquery.p = 1
		this.detailquery.rollpage = 10
		this.detailquery.date = []
		this.detailquery.brandid = ''
		this.detailList = []
	},
	getDetailList(id) {
		this.detailquery.date = this.brandQuery.date
		id ? this.detailquery.brandid = id : ''

		this.detailLoading = true
		var resource = this.$resource(this.GLOBAL.domain+"/Stat/index");
        resource.query(this.detailquery).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                this.detailList = JSON.parse(Base64.decode(res.data.Data));
				this.detailTotal = res.data.count
            }
        }).finally(() => {
			this.detailLoading = false
		})
	},
	detailSizeChange(val) {
		this.detailquery.rollpage = val;
		this.getDetailList();
	},
	detailCurrentChange(val) {
		this.detailquery.p = val;
        this.getDetailList();
	},
    /** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },

	/** 获取线上发货单来源代理商 **/
    getsourceagent() {
		var resource = this.$resource(this.GLOBAL.domain+"Sell/index");
        resource.query({act:'getsourceagent',token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                this.sourceagents = JSON.parse(Base64.decode(res.data.Data));
            }
        }).catch((res) => {
            
        });
	},
    
    //获取销售员
    getSeller(){
      var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        }else{
          this.sellerLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    /** 获取客户名称列表 **/
    getcustomers() {
    	var resource = this.$resource(this.GLOBAL.domain+"Customer/index");
	    resource.query({act:'lists',token:this.$cookies.get('token')}).then((res) => {
	    	if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
	        }else{
		    	this.customerlists = JSON.parse(Base64.decode(res.data.Data));
	        }
	    }).catch((res) => {
	        
	    });
    },


	/** 获取商品信息列表 **/
	getgoods(query) {
		if (query !== '') {
	        this.sellgoodsloading = true;
	        var resource = this.$resource(this.GLOBAL.domain+"Product/index");
	        resource.query({act:'lists',key:query,p:1,rollpage:100000000,token:this.$cookies.get('token')}).then((res) => {
	            if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.sellgoodsloading = false;
	            }else{
		            this.sellgoodslists = JSON.parse(Base64.decode(res.data.Data));
		            this.sellgoodsloading = false;
	            }
	        }).catch((res) => {
	            this.sellgoodsloading = false;
	        });
        }
	},


	/** 获取商品信息列表 **/
	getProducts(query) {
		if (query !== '') {
	        this.customerLoading = true;
	        var resource = this.$resource(this.GLOBAL.domain+"Product/index");
	        resource.query({act:'lists',key:query,p:1,rollpage:100000000,token:this.$cookies.get('token')}).then((res) => {
	            if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.customerLoading = false;
	            }else{
		            this.searchproducts = JSON.parse(Base64.decode(res.data.Data));
		            this.customerLoading = false;
	            }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	            this.customerLoading = false;
	        });
        }
	},

    
    /** 获取客户 **/
    getCustomer(query){
        if (query !== '') {
	        this.customerLoading = true;
	        var resource = this.$resource(this.GLOBAL.domain+"Customer/index");
	        resource.query({act:'lists',key:query,token:this.$cookies.get('token')}).then((res) => {
	            if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.customerLoading = false;
	            }else{
		            this.customerLists = JSON.parse(Base64.decode(res.data.Data));
		            this.customerLoading = false;
	            }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	            this.customerLoading = false;
	        });
        }
    },
    
    /** 支付方式列表 **/
    getpaylists() {
    	var _this=this;
    	var resource = this.$resource(this.GLOBAL.domain+"Account/index");
        resource.query({act:'lists',isdeposit:1,isnopay:1,token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.paylists = JSON.parse(Base64.decode(res.data.Data));
	            this.paylists.forEach(function(e,index) {
	            	if(e.id==0) _this.paylists[index]['id']='01';
	            });
	        }
        }).catch((res) => {
           
        });
    },
    
    //获取品牌
    getBrand(){
      var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        }else{
          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    //获取分类列表
    getCategoryList(){
      var resource = this.$resource(this.GLOBAL.domain+"Product/index");
      resource.query({ act:'getcatelist',token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        }else{
          this.categorylist = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    //信息列表
    getList(){
      if(this.isselect==true) {
		  this.query.p=1;
		  this.query.rollpage=10;	    	
      }
      
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save(this.query).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
        }else{
          var _this=this;
          var total=0.00; //合计订单总额
          var real=0.00; //合计实付金额
          var derate=0.00; //合计优惠金额
          var amount=0.00; //合计已付金额
          this.lists = JSON.parse(Base64.decode(res.data.Data));          
          this.total_rows=parseInt(res.data.count);
          this.listLoading = false;
          this.getAllstat(); //重新计算订单金额和实付金额
        }       
        if(this.isselect==true) this.isselect=false;
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
          if(this.isselect==true) this.isselect=false;
      });
    },
    pageSizeChange(val) {
		this.query.p = 1;
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    
    /** 获取订单统计 **/
    getAllstat(){    
        var resource = this.$resource(this.GLOBAL.domain+"Sell/index");
        resource.save({act:'getAllstat',productid:this.query.productid,clerkid:this.query.clerkid,customerid:this.query.customerid,date:this.query.date,account:this.query.account,documents:this.query.key,timetype:this.query.timetype,datafrom:this.query.datafrom,fagentid:this.query.fagentid,token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
        }else{
            this.allstat = JSON.parse(Base64.decode(res.data.Data));
        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    //导出订单信息
    sumTypeCkeck(type) {
    	if(type==1) this.exportorderlists(); //导出销售订单列表
    	if(type==2) this.exportorderdetail(); //导出销售订单详情
    },
    
    //导出销售订单列表
    exportorderlists() {
		// 构建基础URL
		const baseUrl = this.GLOBAL.exportUrl + 'Stat/index';
		
		// 创建URLSearchParams对象
		const params = new URLSearchParams();
		
		// 添加基本参数
		params.append('act', 'getoutdata');
		params.append('token', this.$cookies.get('token'));
		params.append('isexport', 1);
		
		// 添加其他可能为空的参数
		const optionalParams = [
			'productid', 'key', 'clerkid', 'customerid', 
			'account', 'timetype', 'datafrom', 'fagentid'
		];
		
		optionalParams.forEach(param => {
			if (this.query[param]) {
				params.append(param, this.query[param]);
			}
		});
		
		// 特殊处理date数组参数
		if (Array.isArray(this.query.date) && this.query.date.length > 0) {
			this.query.date.forEach(date => {
				params.append('date[]', date); // 关键点：使用date[]格式
			});
		}
		
		// 构建完整URL
		const downloadUrl = `${baseUrl}?${params.toString()}`;
		
		// 创建隐藏的a标签并触发下载
		const link = document.createElement('a');
		link.style.display = 'none';
		link.href = downloadUrl;
		document.body.appendChild(link);
		link.click();
		
		// 清理DOM
		setTimeout(() => {
			document.body.removeChild(link);
		}, 100);
	},
    
    //导出销售订单详情
    exportorderdetail() {
		// 构建基础URL
		const baseUrl = this.GLOBAL.exportUrl + 'Stat/index';
		
		// 创建URLSearchParams对象
		const params = new URLSearchParams();
		
		// 添加固定参数
		params.append('act', 'getoutdetaildata');
		params.append('token', this.$cookies.get('token'));
		params.append('isexport', 1);
		
		// 添加其他可能为空的参数
		const optionalParams = [
			'productid', 'key', 'clerkid', 'customerid', 
			'account', 'timetype', 'datafrom'
		];
		
		optionalParams.forEach(param => {
			if (this.query[param]) {
				params.append(param, this.query[param]);
			}
		});
		
		// 特殊处理date数组参数
		if (Array.isArray(this.query.date) && this.query.date.length > 0) {
			this.query.date.forEach(date => {
				params.append('date[]', date);
			});
		}
		
		// 构建完整URL
		const downloadUrl = `${baseUrl}?${params.toString()}`;
		
		// 创建隐藏的a标签并触发下载
		const link = document.createElement('a');
		link.style.display = 'none';
		link.href = downloadUrl;
		document.body.appendChild(link);
		link.click();
		
		// 清理DOM
		setTimeout(() => {
			document.body.removeChild(link);
		}, 100);
		
		// 可选：显示成功提示
		this.$message.success('正在导出详情...');
	},
    
    
    /////////////////////////////////////////////////////////////////////////////////
    //展开、收缩表单多选
    showformheight() {
    	this.showformmore.height=='3em' ? this.showformmore.height='6em' : this.showformmore.height='3em';
    },
    
    //按商品信息搜索
    getproductList(){
      if(this.productisselect==true) {
      	  this.productquery.p=1;
      	  this.productquery.rollpage=10;
      }
    
      this.productlistLoading = true;
      var resource = this.$resource(this.url);
      resource.save(this.productquery).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.productlistLoading = false;
        }else{
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.productlists=result.lists;
          this.amounts=result.amount;
          this.product_total_rows=parseInt(res.data.count);
          this.productlistLoading = false;
        }
        
        if(this.productisselect==true) this.productisselect=false;
      }).catch((res) => {
          this.productlistLoading=false;
      });
    },
    productpageSizeChange(val) {
        this.productquery.rollpage = val;
        this.getproductList();
    },
    productpageCurrentChange(val) {
        this.productquery.p = val;
        this.getproductList();
    },
    
    //按商品获取销售数据
    getproductexport() {
    	this.goodsDialog=true;
		this.goodsLoading=true;    
    	var resource = this.$resource(this.GLOBAL.exportUrl+'Stat/index');
	    resource.query({act:'exportgoodsdata',token:this.$cookies.get('token'),brandid:this.productquery.brandid,clerkid:this.productquery.clerkid,catid:this.productquery.catid,date:this.productquery.date,key:this.productquery.key,customerid:this.productquery.customerid,isexport:1}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.goodsLists = JSON.parse(Base64.decode(res.data.Data));
	            this.goodsLoading=false;    
	        }
	    }).catch((res) => {
	          
	    });
    },
    
    ///////////////////////////////////////////////////////////////
    //按客户查询
  	customergetlists(){
  	    this.customerlistLoading=true;
	    var resource = this.$resource(this.url);
	    resource.save(this.customerquery).then((res) => {
	        if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.customerlistLoading=false;
	        }else{
		        this.customerslists = JSON.parse(Base64.decode(res.data.Data));
		        this.customertotal_rows=parseInt(res.data.count);
		        this.customerlistLoading=false;
	        }
	    }).catch((res) => {
	        this.customerlistLoading=false;
	    });
    },
      
    customerpageSizeChange(val) {
        this.customerquery.rollpage = val;
        this.customergetlists();
    },
    customerpageCurrentChange(val) {
        this.customerquery.p = val;
        this.customergetlists();
    },
    
    //按客户倒出商品销售信息
    customerexportdatamore() {
    	this.customerDialog=true;
    	this.customerexportLoading=true;
	    var resource = this.$resource(this.GLOBAL.exportUrl+'Stat/index');	    
	    resource.query({token:this.$cookies.get('token'),act:'getcustomerexportdata',key:this.customerquery.key,date:this.customerquery.date,clerkid:this.customerquery.clerkid,account:this.customerquery.account,brandid:this.customerquery.brandid,catid:this.customerquery.catid,customer:this.customerquery.customer,type:this.customerquery.type,productid:this.customerquery.productid,isexport:1}).then((res) => {
	        if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.customerexportLoading=false;
	        }else{
		        this.customersexport = JSON.parse(Base64.decode(res.data.Data));
		        this.customerexportLoading=false;
	        }
	    }).catch((res) => {
	        this.customerexportLoading=false;
	    });
    },
    
    
    /////////////////////////////////////////////////////////////////
    //按区域查询    
    areagetlists() {
    	if(this.areaselect==true) {
    		this.areaquery.p=1;
    		this.areaquery.rollpage=10;
    	}
    
    	this.areaLoading=true;
	    var resource = this.$resource(this.url);
	    resource.save(this.areaquery).then((res) => {
	        if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.areaLoading=false;
	        }else{
		        this.arealists = JSON.parse(Base64.decode(res.data.Data));
		        this.areatitle1=this.arealists.title[0];
		        this.areatitle2=this.arealists.title[1];
		        this.area_rows=parseInt(res.data.count);
		        this.areaLoading=false;
		        if(this.areaselect==true) this.areaselect=false;
	        }
	    }).catch((res) => {
	        this.areaLoading=false;
	    });
    },
    areapageSizeChange(val) {
        this.areaquery.rollpage = val;
        this.areagetlists();
    },
    areapageCurrentChange(val) {
        this.areaquery.p = val;
        this.areagetlists();
    },
    
    //按区域导出信息
    areaexportdatamore() {
    	this.areaDialog=true;
    	this.areaexportLoading=true;
	    var resource = this.$resource(this.GLOBAL.exportUrl+'Stat/index');
	    resource.query({act:'getareaexportdata',token:this.$cookies.get('token'),brandid:this.areaquery.brandid,key:this.areaquery.key,date:this.areaquery.date,isexport:1}).then((res) => {
	        if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.areaexportLoading=false;
	        }else{
		        this.areaexport = JSON.parse(Base64.decode(res.data.Data));
		        this.areaexportLoading=false;
	        }
	    }).catch((res) => {
	        this.areaexportLoading=false;
	    });
    },
    
    
    /////////////////////////////////////////////////////////////////////////////////
    //按销售员查询
    sellgetlists() {
    	if(this.sellselect==true) {
    		this.sellquery.p=1;
    		this.sellquery.rollpage=10;
    	}
    
    	this.sellLoading=true;
	    var resource = this.$resource(this.url);
	    resource.save(this.sellquery).then((res) => {
	        if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.sellLoading=false;
	        }else{
		        var result = JSON.parse(Base64.decode(res.data.Data));
		        this.sellsalelists=result.lists;
		        this.allsale=result.sale;
		        this.allreal=result.real;
		        this.allrefund=result.refund;
		        this.allpay=result.pay;
		        
		        this.sell_rows=parseInt(res.data.count);
		        this.sellLoading=false;
		        if(this.sellselect==true) this.sellselect=false;
	        }
	    }).catch((res) => {
	        this.sellLoading=false;
	    });
    },
    
    sellpageSizeChange(val) {
        this.sellquery.rollpage = val;
        this.sellgetlists();
    },
    sellpageCurrentChange(val) {
        this.sellquery.p = val;
        this.sellgetlists();
    },

	//按销售员导出销售信息
	exportsellstatnew() {
		this.clerksellDialog=true;
		this.clerkLoading=true;
	    var resource = this.$resource(this.GLOBAL.exportUrl+"Stat/index");
	    resource.query({act:'exportsellstatnew',token:this.$cookies.get('token'),brandid:this.sellquery.brandid,clerkid:this.sellquery.clerkid,key:this.sellquery.key,date:this.sellquery.date}).then((res) => {
	        if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.clerkLoading=false;
	        }else{
		        var result = JSON.parse(Base64.decode(res.data.Data));
		        this.clerksalelists=result;
		        this.clerkLoading=false;
	        }
	    }).catch((res) => {
	        this.clerkLoading=false;
	    });
	},

    
    //切换标签
    handleTabsEdit(id) {
    	var _this=this;
    	var number=id-1;
    	this.typelists.forEach(function(e,i) {
    		_this.typelists[i].background.background='#909399';
    		_this.typelists[i].background.padding='8px 20px'; 
    		_this.typelists[i].color.color='#fff';  
    		_this.typelists[i].show=false;    	  		
    	});
    	_this.typelists[number].background.background='#fff';
    	_this.typelists[number].background.padding='8px 40px';
    	_this.typelists[number].color.color='#606266';
    	_this.typelists[number].show=true;
    	
    	//获取默认设置时间
	  	var year=new Date().getFullYear().toString();
	  	var month=new Date().getMonth()+1;
	  	var day=new Date().getDate();
		month < 10 ? month='0'+month : '';
		day < 10 ? day='0'+day : '';
		var defaultday=year+'-'+month+'-'+day;
    	
    	this.tabvalue=id;
    	if(this.tabvalue==1) { //按订单
    		//重置搜索信息
	        this.query.key='';
	        this.query.rollpage=10;
	        this.query.p=1;
	        this.query.date=[defaultday,defaultday];
	        this.query.clerkid='';
	        this.query.customerid='';
	        this.query.account='';
    		this.getList();
    	}else if(this.tabvalue==2) { //按商品
    		this.productquery.customerid='';
	        this.productquery.brandid='';
	        this.productquery.clerkid='';
	        this.productquery.catid=[];
	        this.productquery.date=[defaultday,defaultday];
	        this.productquery.key='';
	        this.productquery.rollpage=10; // 页大小
	        this.productquery.p=1;
	        this.getproductList();
    	}else if(this.tabvalue==3) {  //按客户
            this.customerquery.key='';
            this.customerquery.coststart='';
            this.customerquery.costend='';
            this.customerquery.rollpage= 10; // 页大小
            this.customerquery.p=1;
            this.customerquery.date=[defaultday,defaultday];
            this.customerquery.clerkid='';
            this.customerquery.account='';
            this.customerquery.brandid='';
            this.customerquery.catid='';
            this.customerquery.customer='';
            this.customerquery.type=1;
            this.customerquery.productid='';
            this.customerquery.startprice='';
            this.customerquery.endprice='';
            this.customergetlists();
    	}else if(this.tabvalue==4) { //按区域
    		this.arealists.p=1;
    		this.arealists.rollpage=10;
    		this.arealists=[];
	        this.areaquery.brandid='';
          	this.areaquery.key='';
          	this.areaquery.date=[defaultday,defaultday];
          	this.areagetlists();
    	}else if(this.tabvalue==5) { //按销售员
            this.sellquery.p=1;
            this.sellquery.rollpage=10; // 页大小
            this.sellquery.brandid='';
            this.sellquery.clerkid='';
            this.sellquery.key='';
            this.sellquery.date=[defaultday,defaultday];
			this.sellgetlists();
    	}else if(this.tabvalue==6) { //按品牌
            this.brandQuery.p=1;
            this.brandQuery.rollpage=10; // 页大小
            this.brandQuery.brandid='';
            this.brandQuery.date=[defaultday,defaultday];
			this.brandSearch();
    	}		

    },
	// 按品牌查询
	brandSearch() {
		this.brandLoading = true
	    var resource = this.$resource(this.GLOBAL.exportUrl+"Stat/index");
	    resource.query(this.brandQuery).then((res) => {
	        if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.clerkLoading=false;
	        }else{
		        var result = JSON.parse(Base64.decode(res.data.Data));
		        this.brandList = result;
				this.brandQueryTotal = res.data.count
	        }
	    })
		.finally(() => {
			this.brandLoading = false
		})
	},
	brandpageCurrentChange(val) {
		this.brandQuery.p = val;
        this.brandSearch();

	},
	brandpageSizeChange(val) {
		this.brandQuery.p = 1;
		this.brandQuery.rollpage = val;
        this.brandSearch();
	},
    
    //导出销售订单列表
    sureoutput() {    
		this.exporthead=['订单编号','订单来源','客户名称','所在区域','销售员','支付方式','下单时间','审核时间','完成时间','订单商品合计数量','订单总价','实付金额','优惠金额','快递费','已付金额','备注','快递信息'];
	    this.exportfield=['documents','paytype','customer','district_name','clerk','accountname','inputtime','verifytime','finishtime','num','total','real','derate','express','amount','note','expressinfos'];
	    this.exportlists=this.outlists;
	    this.exportname='销售订单列表';
	    this.exportput();
	    this.outputDialog=false;		
    },
    
    suredetailoutput() {
		// 基础表头（包括仓库后的货位、类型、分拣箱号等）
		this.exporthead = [
			'订单编号', '订单来源', '下单时间', '审核时间', '完成时间', 
			'客户', '销售员', '订单金额', '应付金额', '优惠金额', 
			'已付金额', '订单状态', '支付', '商品编码', '品牌', 
			'条形码', '品类', '商品名称', '价格', '零售价', 
			'折扣%', '数量', '规格', '单位', '成本小计', 
			'销售金额小计', '仓库',
			// 动态添加货位（位置在仓库后）
			...(this.storageLocationStatus ? ['货位'] : []), // 根据开关动态添加
			'类型', '订单备注',
			// 分拣箱号和审核人员
			'分拣箱号', '审核人员'
		];
		
		this.exportfield = [
			'documents', 'paytype', 'inputtime', 'verifytime', 'finishtime',
			'customername', 'clerkname', 'total', 'real', 'derate',
			'amount', 'status', 'account', 'number', 'brandname',
			'code', 'cate', 'name', 'sell', 'market',
			'discount', 'num', 'spec', 'unit', 'cost',
			'goodstotal', 'warehousename',
			// 动态添加货位字段（位置在仓库字段后）
			...(this.storageLocationStatus ? ['storage_location_str'] : []), // 添加处理后的字符串字段
			'type', 'note',
			// 分拣箱号和审核人员
			'sorting_box_str', 'verifyer_name'
		];

		// 处理数据：数组转字符串格式
		this.exportlists = this.outldetailists.map(item => {
			// 1. 处理货位数组
			const storageLocation = (item.storage_location || [])
				.map(loc => loc.full_code)
				.join(',');
			
			// 2. 处理分拣箱号数组
			const sortingBox = (item.sorting_box || [])
				.map(box => `${box.box_name}号箱:${box.box_volume}`)
				.join(',');
			
			// 创建新对象（保留原有字段，添加处理后的字段）
			return {
				...item,
				// 添加处理后的字段
				storage_location_str: storageLocation,
				sorting_box_str: sortingBox
			};
		});

		this.exportname = '销售订单明细表';
		this.exportput();
		this.outputdetailDialog = false;
	},
    
    //按商品导出销售数据
    productoutput() {
    	this.exporthead=['商品编号','品牌','商品名称','规格','最新进货价','最新批发价','销售数量','单位','销售金额','剩余库存数量','剩余库存金额'];
	    this.exportfield=['number','brandname','name','spec','buy','sell','sellnum','unit','selltotal','storagenum','storagetotal'];
	    this.exportlists=this.goodsLists;
	    this.exportname='商品销售明细';
	    this.exportput();
	    this.goodsDialog=false;		
    },
    
    //按客户导出销售数据
    customeroutput() {
    	this.exporthead=['客户名称','订单编号','下单时间','完成时间','品牌','商品名称','商品编号','条形码','规格','当前批发价','当前零售价','售价','数量','单位','合计金额','类型','备注'];
	    this.exportfield=['customername','documents','inputtime','finishtime','brandname','name','number','basebarcode','spec','sellprice','market','sell','num','unit','total','type','desc'];
	    this.exportlists=this.customersexport;
	    this.exportname='客户销售明细';
	    this.exportput();
	    this.customerDialog=false;		
    },

	//按客户导出销售数据2
	customerstatoutput() {
		this.exporthead=['客户名称','客户手机','所在城市','详细地址','订单笔数','订单金额','优惠金额','应付金额','赠品金额','毛利','毛利率'];
	    this.exportfield=['name','phone','city','address','number','total','derate','real','gift','gross','percent'];
	    this.exportlists=this.customerstatdata;
	    this.exportname='客户销售统计';
	    this.exportput();
	    this.customerstatdataDialog=false;		
	},


	//按销售员导出销售数据
	clerkoutput() {
		this.exporthead=['订单编号','销售员名称','客户名称','支付方式','订单金额','实付金额','未付款金额','利润','下单时间','完成时间'];
	    this.exportfield=['documents','clerkname','customername','accountname','total','real','pay','profit','inputtime','finishtime'];
	    this.exportlists=this.clerksalelists;
	    this.exportname='销售员销售信息表';
	    this.exportput();
	    this.clerksellDialog=false;		
	},
    
    //按区域到处销售数据
    areaoutput() {
    	var _this=this;
    	var nums='';
    	var total='';
    	var number=0;
    	this.exporthead=this.areaexport.title;
	    this.exportfield=['number','name','spec','unit'];
	    for (var i=0;i<this.areaexport.count;i++) {
			number += 1;
			nums='districtnums'+number;
	    	total='districttotal'+number;
			_this.exportfield.push(nums);
	    	_this.exportfield.push(total);
		}
	    this.exportfield.push('allnum');
	    this.exportfield.push('amount');
	    this.exportlists=this.areaexport.lists;
	    this.exportname='商品区域销售明细';
	    this.exportput();
	    this.areaDialog=false;		
    },
    
    /** 确认导出信息 **/
    exportput() {
		require.ensure([], () => {
			var { export_json_to_excel } = require('../../vendor/Export2Excel');
			var data = this.formatJson(this.exportfield, this.exportlists);
			export_json_to_excel(this.exporthead, data, this.exportname);
		})
    },
    
    //导出表格数据
	formatJson(filterVal, jsonData) {
　　　　return jsonData.map(v => filterVal.map(j => v[j]));
　　}, 

    //客户信息统计导出
	customersumTypeCkeck(val) {
		if(val==1) this.customerexportdatamore();
		if(val==2) this.customerstatexportdatamore();
	},

	//导出客户信息统计列表
	customerstatexportdatamore() {
		this.customerstatdataDialog=true;
    	this.customerstatdataloading=true;
		this.customerstatdata=[];
	    var resource = this.$resource(this.GLOBAL.exportUrl+'Stat/index');	    
	    resource.query({token:this.$cookies.get('token'),act:'getcustomerstatexportdata',key:this.customerquery.key,date:this.customerquery.date,clerkid:this.customerquery.clerkid,account:this.customerquery.account,brandid:this.customerquery.brandid,catid:this.customerquery.catid,customer:this.customerquery.customer,type:this.customerquery.type,productid:this.customerquery.productid,isexport:1}).then((res) => {
	        if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.customerstatdataloading=false;
	        }else{
		        this.customerstatdata = JSON.parse(Base64.decode(res.data.Data));
		        this.customerstatdataloading=false;
	        }
	    }).catch((res) => {
	        this.customerstatdataloading=false;
	    });
	},

	//导出销售员销售品牌信息数据
	clerksumTypeCkeck(val) {
		if(val==1) this.exportsellstatnew();
		if(val==2) this.exportclerksellstatnews();
	},

	exportclerksellstatnews() {
		//按销售员导出销售信息
		this.clerksellbrandDialog=true;
		this.clerkbrandLoading=true;
		this.clerkbrandsalelists=[];
	    //var resource = this.$resource(this.GLOBAL.exportUrl+"Stat/index");
		var url=this.url;
		url+="/act/exportsellbrandstatnew/token/"+this.$cookies.get('token');

		if(!this.sellquery.date) {this.$message.error("请选择查询时间");return false;}

		if(this.sellquery.brandid > 0) url+="/brandid/"+this.sellquery.brandid;
		if(this.sellquery.clerkid > 0) url+="/clerkid/"+this.sellquery.clerkid;
		if(this.sellquery.key!='') url+="/key/"+this.sellquery.key;
		if(this.sellquery.date) url+="/start/"+this.sellquery.date[0]+"/end/"+this.sellquery.date[1];
		location.href=url;
	},
    
     
  }
}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.titlelists {float:left;width:100%;padding:0;margin:0}
.titlelists li {float:left;width:33.3%;font-size:15px;list-style-type:none}
.top1 td {padding-top:5px;font-size:15px}
.top2 td {padding-top:15px;font-size:15px}
.tablists {margin:0;padding:0 0 0 1%}
.tablists li {float:left;font-size:13px;line-height:23px;margin-left:10px;margin-top:10px;border-radius:10px 10px 0 0;list-style-type:none;border:1px solid #ddd;border-bottom:none;transition: padding 0.3s 0s;}
.tablists li a {float:left;width:100%;color:#fff;text-decoration:none;font-size:12px;}
.salemain {padding:2% 2% 3% 2%;background:#fff;border-radius:5px;float:left;width:96%;}

.backborder3 {background:#fff;border-radius:5px;border:1px solid #ddd;float:left;width:98%;padding:1% 1% 1% 1%;}
.statout {position:relative;width:20%;height:5%;margin-right:2%;float:left;border:1px solid #E4E7ED;border-radius:5px}
.statout img {float:left;width:24%;padding:6% 5%}
.statout .number {float:left;width:61%;padding-left:5%;margin-top:8%;color:#fff;font-weight:bold;font-size:20px;}
.statout .number a {text-decoration:underline;color:#fff}
.statout .desc {float:left;width:61%;padding-left:5%;margin-top:0;color:#fff;font-size:14px;}
.stattotal {float:left;width:100%;padding:0;margin:0 0 1% 0}
.stattotal li {width:15%;height:5%;margin-right:1%;float:left;border:1px solid #E4E7ED;border-radius:5px;list-style-type:none;}
.stattotal li img {float:left;width:24%;padding:6% 5%}
.stattotal .number {float:left;width:65%;padding-left:1%;margin-top:5%;color:#fff;font-weight:bold;font-size:1em;}
.stattotal .desc {float:left;width:65%;padding-left:1%;margin-top:0;color:#fff;font-size:0.7em;line-height:1em;border:none;text-align:left}
.formmore {overflow:hidden;transition: height 0.3s 0s;}

.tableshow1 {width:100%;border:1px solid #ebeef5;color:#606266;border-collapse: collapse;}
.tableshow1 tr th,.tableshow1 tr td {width:auto;white-space:nowrap;border:1px solid #ebeef5;padding:10px 15px 10px 15px;font-size:14px;}
</style>


// WEBPACK FOOTER //
// src/components/stat/StatSale.vue